import { useEffect } from 'react'

import {
  ConversationTable,
  ConversationDrawerChat,
  ConversationDrawerShow,
  ConversationDrawerNew,
} from '../components'

import { useAIConversationList } from '@/services'

import { useParamsState } from '@/helpers'

import styles from './acquisition.module.css'

import { AcquisitionProps } from './acquisition.type'

export const ConversationsAcquisition = ({
  initialFilters,
}: AcquisitionProps) => {
  const [filter, setFilter] = useParamsState({
    search: '',
    page: '1',
    limit: '10',
    isNotificationOnly: 'false',
    role: '',
    buyerPhones: initialFilters?.buyerPhones?.join(',') || '',
    rfqReference: '',
  })

  const { data, isLoading } = useAIConversationList({
    params: {
      search: filter.search,
      page: filter.page,
      limit: filter.limit,
      isNotificationOnly: filter.isNotificationOnly,
      role: filter.role,
      buyerPhones: filter.buyerPhones,
      rfqReference: filter.rfqReference,
    },
  })

  const [queryParams, setQueryParams] = useParamsState({
    uuid: '',
    show: '',
    new: '',
    form: '',
  })

  const onHandleEditRegister = (uuid: string) => {
    setQueryParams({ ...queryParams, form: 'true', show: '', new: '', uuid })
  }

  const onHandleNewRegister = () => {
    setQueryParams({
      ...queryParams,
      new: 'true',
      form: '',
      show: '',
      uuid: '',
    })
  }

  const onHandleShowRegister = (uuid: string) => {
    setQueryParams({ ...queryParams, show: 'true', form: '', new: '', uuid })
  }

  useEffect(() => {
    if (Object.keys(initialFilters || {}).length) {
      setFilter({
        ...filter,
        buyerPhones: initialFilters?.buyerPhones?.join(',') || '',
      })
    }
  }, [initialFilters])

  return (
    <div className={styles.content}>
      <ConversationTable
        type="acquisition"
        data={data?.data}
        isLoading={isLoading}
        filter={filter}
        onSetFilter={setFilter}
        onHandleEditRegister={onHandleEditRegister}
        onHandleNewRegister={onHandleNewRegister}
        onHandleShowRegister={onHandleShowRegister}
      />

      <ConversationDrawerChat
        isOpen={queryParams.form === 'true'}
        onClose={() => setQueryParams({ ...queryParams, form: '' })}
        uuid={queryParams.uuid}
      />

      <ConversationDrawerShow
        isOpen={queryParams.show === 'true'}
        onHandleOpen={() => setQueryParams({ ...queryParams, show: '' })}
        uuid={queryParams.uuid}
        variation="acquisition"
      />

      <ConversationDrawerNew
        isOpen={queryParams.new === 'true'}
        onHandleOpen={() => setQueryParams({ ...queryParams, new: '' })}
      />
    </div>
  )
}
